import React from "react";
import "./PortfolioBox.scss";
import { Link } from "react-router-dom";

function PortfolioBox(props) {
  return (
    <div className={`portfolio_wapper`}>
      <div className="portfolio_box">
        <img
          width="650px"
          height="650px"
          src={props.Image}
          alt={props.alt}
          title={props.cap}
        />
        <div className="project_details">
          <h2>{props.Name}</h2>
          <h4>{props.Technology}</h4>
          {props.Link &&
            <Link target="_blank" to={props.Link}>
              Visit Site
            </Link>
          }
        </div>
      </div>
    </div>
  );
}
export default React.memo(PortfolioBox);
